import { PRODUCTION_MODE } from './environment';

const PROD_API_URL = 'https://mars-api.services.urbanpiper.com';

export let API_URL = 'https://mars-api.services.urbanpiper.com';

// API_URL = process.env.REACT_APP_API_URL;
